import { Form, Input, InputNumber } from "antd";
import React from "react";

const SubjectHeight: React.FC = () => {
  return (
    <Form.Item name={["subjectMetric", "height"]} label="Height (cm)">
      <InputNumber
        controls={false}
        changeOnWheel={false}
        style={{ width: "100%" }}
      />
    </Form.Item>
  );
};

export default SubjectHeight;
